"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileDropdown = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _localization = require("@lt/localization");
var _react = _interopRequireWildcard(require("react"));
var _SearcherDropdownLabel = _interopRequireDefault(require("../SearcherDropdown/SearcherDropdownLabel"));
var _SearcherFormMobileLayout = require("../SearcherFormMobileLayout/SearcherFormMobileLayout");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Components:

var MobileDropdown = exports.MobileDropdown = function MobileDropdown(props) {
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$dropdownLabel = props.dropdownLabel,
    dropdownLabel = _props$dropdownLabel === void 0 ? '' : _props$dropdownLabel,
    _props$submitButtonTe = props.submitButtonText,
    submitButtonText = _props$submitButtonTe === void 0 ? t('touristsPicker.button.apply') : _props$submitButtonTe,
    CustomDropdownLabel = props.CustomDropdownLabel,
    popupLabel = props.popupLabel,
    children = props.children,
    onSubmit = props.onSubmit,
    onCancel = props.onCancel,
    containerStyles = props.containerStyles,
    _props$onAnimationEnd = props.onAnimationEnd,
    onAnimationEnd = _props$onAnimationEnd === void 0 ? function () {
      return undefined;
    } : _props$onAnimationEnd,
    _props$onControlClick = props.onControlClick,
    onControlClick = _props$onControlClick === void 0 ? function () {
      return undefined;
    } : _props$onControlClick,
    _props$fullControl = props.fullControl,
    fullControl = _props$fullControl === void 0 ? false : _props$fullControl,
    _props$open = props.open,
    isOpen = _props$open === void 0 ? false : _props$open,
    withHeader = props.withHeader,
    isWhiteLabel = props.isWhiteLabel,
    isSearcher = props.isSearcher;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    focus = _useState4[0],
    setFocus = _useState4[1];
  var handleFocus = function handleFocus() {
    return setFocus(true);
  };
  var handleBlur = function handleBlur() {
    return setFocus(false);
  };
  var handleClick = function handleClick() {
    setOpen(true);
    onControlClick();
  };
  var handleCancel = function handleCancel() {
    setOpen(false);
    onCancel === null || onCancel === void 0 || onCancel();
  };
  var handleSubmit = function handleSubmit() {
    setOpen(false);
    onSubmit === null || onSubmit === void 0 || onSubmit();
  };
  var isModalOpen = fullControl ? isOpen : open;
  var DropdownLabel = CustomDropdownLabel || _SearcherDropdownLabel["default"];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleClick,
    onFocus: handleFocus,
    onBlur: handleBlur
  }, /*#__PURE__*/_react["default"].createElement(DropdownLabel, {
    isOpen: isModalOpen,
    focused: focus
  }, dropdownLabel)), /*#__PURE__*/_react["default"].createElement(_SearcherFormMobileLayout.SearcherFormMobileLayout, {
    popupLabel: popupLabel || '',
    open: isModalOpen,
    submitButtonText: submitButtonText,
    onSubmit: handleSubmit,
    onCancel: handleCancel,
    onAnimationEnd: onAnimationEnd,
    containerStyles: containerStyles,
    withHeader: withHeader,
    isWhiteLabel: isWhiteLabel,
    isSearcher: isSearcher
  }, children));
};